import { useWebSocket as useWs } from '@vueuse/core'

export const useWebSocket = () => {
  const url = `wss://${DOT_ENV.WEBSOCKET_API_ENDPOINT}`
  // const url = 'ws://localhost:3001'
  const { status, data, send } = useWs(url, {
    autoReconnect: true,
    heartbear: { interval: 10000 }
  })
  const sendJson = data => send(JSON.stringify(data))

  return {
    status,
    data,
    send,
    sendJson
  }
}
